const cards = [
  {
    title: '星际迷途：新纪元',
    tag: '科幻巨制',
    desc: '人类在遥远星系建立殖民地后遭遇未知文明，一场关乎存亡的史诗对决即将展开。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20distant%20galaxy%20and%20nebula%20glowing%20in%20warm%20amber%20and%20deep%20crimson%20hues%2C%20cinematic%20space%20opera%20atmosphere%2C%20majestic%20starship%20silhouette%2C%20no%20text%20no%20faces%20no%20logos%2C%20dramatic%20lighting&width=800&height=560&seq=card-01-scifi&orientation=landscape',
    alt: '星际迷途：新纪元',
  },
  {
    title: '笑傲江湖之风云再起',
    tag: '动作喜剧',
    desc: '无名小卒误入江湖纷争，阴差阳错间笑料百出，最终以独特方式化解武林恩怨。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20village%20at%20golden%20sunset%20with%20warm%20earthy%20tones%2C%20traditional%20wooden%20architecture%2C%20misty%20mountain%20background%2C%20cinematic%20wuxia%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos%2C%20atmospheric%20lighting&width=800&height=560&seq=card-02-comedy&orientation=landscape',
    alt: '笑傲江湖之风云再起',
  },
  {
    title: '暗夜追踪',
    tag: '悬疑惊悚',
    desc: '一座孤岛上的连环失踪案，侦探深入调查后发现真相远比想象的更加骇人。',
    img: 'https://readdy.ai/api/search-image?query=Moody%20foggy%20island%20lighthouse%20scene%20at%20twilight%20with%20deep%20shadows%20and%20warm%20amber%20window%20glow%2C%20atmospheric%20mystery%20thriller%20aesthetic%2C%20dramatic%20contrast%20lighting%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=560&seq=card-03-thriller&orientation=landscape',
    alt: '暗夜追踪',
  },
  {
    title: '花样年华·续',
    tag: '文艺剧情',
    desc: '跨越二十年的情感羁绊，在都市霓虹下重新相遇的两个人，能否续写未竟的故事。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20city%20street%20at%20night%20with%20soft%20golden%20neon%20reflections%20on%20wet%20pavement%2C%20vintage%20cinematic%20mood%2C%20warm%20intimate%20atmosphere%2C%20elegant%20composition%2C%20no%20text%20no%20faces%20no%20logos%2C%20dreamy%20bokeh&width=800&height=560&seq=card-04-romance&orientation=landscape',
    alt: '花样年华·续',
  },
  {
    title: '极地奇迹',
    tag: '动画冒险',
    desc: '一只勇敢的小企鹅踏上穿越南极的旅程，途中结识伙伴共同面对严酷自然的考验。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20arctic%20aurora%20borealis%20scene%20with%20stunning%20green%20and%20teal%20sky%20over%20snowy%20icy%20landscape%2C%20magical%20winter%20wonderland%20atmosphere%2C%20soft%20ethereal%20glow%2C%20no%20text%20no%20faces%20no%20logos%2C%20cinematic%20wide%20shot&width=800&height=560&seq=card-05-animation&orientation=landscape',
    alt: '极地奇迹',
  },
  {
    title: '热血拳台',
    tag: '运动励志',
    desc: '退役拳手重返擂台，为尊严与梦想最后一战，用血与汗水书写不屈传奇。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20boxing%20ring%20illuminated%20by%20a%20single%20warm%20overhead%20spotlight%20in%20a%20dark%20arena%2C%20atmospheric%20dust%20particles%20in%20light%20beam%2C%20cinematic%20sports%20drama%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos%2C%20intense%20mood&width=800&height=560&seq=card-06-sports&orientation=landscape',
    alt: '热血拳台',
  },
  {
    title: '地球脉动：海洋深处',
    tag: '纪录片',
    desc: '深入从未被拍摄过的深海世界，揭示蓝色星球最神秘的生命奇观与壮美生态。',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20deep%20ocean%20scene%20with%20sunlight%20rays%20penetrating%20crystal%20clear%20blue%20water%2C%20beautiful%20coral%20reef%20ecosystem%2C%20ethereal%20underwater%20atmosphere%2C%20cinematic%20nature%20documentary%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=560&seq=card-07-nature&orientation=landscape',
    alt: '地球脉动：海洋深处',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            每日更新的高清电影推荐，发现属于您的好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((item, i) => (
            <div
              key={i}
              className={`group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200 ${
                i === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'h-72' : 'h-44'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}